export const api = {
  url: 'https://dormitory-reservation-api.herokuapp.com'
  // url: 'http://localhost:3000'
};
